<template>
  <v-container fluid>
    <v-card
      class="mx-auto"
      :max-width="$vuetify.breakpoint.mdAndUp ? '100%' : '90%'"
      style="height: 100%"
      elevation="4"
    >
      <v-img
        height="100%"
        :src="getCardBackgroundImage"
        gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,1)"
      >
        <div
          class="d-flex justify-space-between"
          style="height: 100%"
          v-if="getAdminData"
        >
          <div>
            <v-avatar class="profile" color="grey" size="164" tile>
              <v-img :src="getStaticProfile"></v-img>
            </v-avatar>
            <v-list-item-title class="white--text text-overline my-auto mx-2"
              >Mi Perfil</v-list-item-title
            >
          </div>
          <div class="d-flex flex-column justify-space-between">
            <div class="ma-2">
              <CambiarPassword />
            </div>
            <div>
              <v-list-item dark>
                <v-list-item-content class="text-right">
                  <span class="grey--text text--lighten-1 text-overline"
                    >Usuario</span
                  >
                  <v-list-item-title class="title text-h4">
                    {{ getAdminData.usuario }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider horizontal inset class="grey lighten-1"></v-divider>
              <v-list-item dark>
                <v-list-item-content class="text-right">
                  <span class="grey--text text--lighten-1 text-overline"
                    >Rol</span
                  >
                  <v-list-item-title class="text-h5">{{
                    getAdminData.adminType
                  }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </div>
        <div v-else>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </div>
        <v-row align="end" class="fill-height">
          <v-col align-self="start" class="pa-0" cols="8"> </v-col>
          <v-col class="py-0" cols="4" align="end"> </v-col>
        </v-row>
      </v-img>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {
    CambiarPassword: () =>
      import("@/components/admin/dialogs/DialogCambiarPassword.vue")
  },

  computed: {
    getStaticProfile() {
      return require("@/assets/anonymous.png");
    },

    getCardBackgroundImage() {
      return require("@/assets/banners/server-room.jpg");
    },

    ...mapGetters("admin", ["getAdminData"])
  }
};
</script>

<style>
</style>